import { useMemo } from "react";
import type { Appointment } from "@/domains/appointment/appointments/types/appointment";
import type { AppointmentListFragment } from "@/gql/graphql";

export const useAppointmentTransform = (
  rawData: AppointmentListFragment[] | any
): Appointment[] => {
  return useMemo(() => {
    // Handle both legacy and new cursor-based data structures
    let appointments: AppointmentListFragment[] = [];

    if (Array.isArray(rawData)) {
      // Direct array of appointments (new cursor-based queries)
      appointments = rawData;
    } else if (rawData?.appointments?.appointments) {
      // Legacy structure
      appointments = rawData.appointments.appointments;
    }

    return appointments.map((appointment: AppointmentListFragment) => appointment);
  }, [rawData]);
};
